<template>
<div class="chapter">
<div class="inner_page">
<h1 class="FBMHD">Recipes</h1>
<p class="SECTION-INTRO1">Now that you have all your basic equipment to hand, you are ready to begin your preparations for baking. You can use almost any recipe for the decorated cupcake projects in this book, and I have listed some of my special favourites here for you to choose from.</p>
<p class="Image"><img alt="" src="images/120314_BMIY_232_fmt.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// c02.vue?99045cc8